import { RequestConfig } from '~/common/services/requests';
import { Doc } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationUncategorizedDocs = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
): Promise<PaginatedResponse<Doc[]> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/docs/uncategorized`, {
    params,
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
      [InceptHeader.RelatedDefinitionName]: 'doc',
    },
  });
